import React, { useEffect, useState, useImperativeHandle } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../redux/reduxActions';
import { Upload, UploadFileInfo, UploadOnAddEvent, UploadOnRemoveEvent, UploadOnProgressEvent, UploadOnStatusChangeEvent, UploadOnBeforeRemoveEvent, UploadFileRestrictions  } from '@progress/kendo-react-upload';
import {TcbFileUploadDefaultsResp} from '../../models/models';
import { useRef } from 'react';
import {FileDisplayModeEnum} from '../../models/enums';
import './FileUploadCtl.css';

const connector = connect(mapStateToProps, mapDispatchToProps, undefined, { forwardRef: true });
type PropsFromRedux = ConnectedProps<typeof connector>;

type FileUploadCtlProps = PropsFromRedux & {
    mode: FileDisplayModeEnum;
    defaultFiles?: Array<UploadFileInfo>;

    onChange: (files: Array<UploadFileInfo>) => void;
    onUploadStart?: () => void;
    onUploadProgress?: (progress: number) => void;
    autoUpload?: boolean;
    hideButtons?: boolean;
    onFilesSelected?: (files: Array<UploadFileInfo>) => void;
    startUploadToken?: number;
    multiple?: boolean;
}

type FileUploadCtlState = {
    files: Array<UploadFileInfo>,
    fileRestrict: UploadFileRestrictions,
    defaultsLoaded: boolean
}


//class FileUploadCtl extends React.Component<FileUploadCtlProps, FileUploadCtlState> {

const FileUploadCtl = React.forwardRef(function FileUploadCtl(props: FileUploadCtlProps, ref: any){

    // constructor(props: FileUploadCtlProps) {
    //     super(props);


        let defFiles: Array<UploadFileInfo> = [];
        if (props.defaultFiles)
            defFiles = props.defaultFiles;


        let rs:UploadFileRestrictions = {};       

        const [state, setState] = useState<FileUploadCtlState>({
            files: defFiles,
            fileRestrict: rs,
            defaultsLoaded: false
        });

  

    // componentDidMount() {
    //     if (!this.state.defaultsLoaded) {
    //         this.fetchUploadDefaults();
    //     }
    // }

    useEffect(() => {
        if (!state.defaultsLoaded) {
            fetchUploadDefaults();
        }
    }, []);

    const fetchUploadDefaults = () => {

        let url: string = props.userInf.currProject.apiUrl + '/api/file/GetTcbFileUploadDefaults';

        fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + props.userInf.token } })
            .then(resp => resp.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        let defs:TcbFileUploadDefaultsResp = res.result;

                        let rs:UploadFileRestrictions = {};
                        // Use server-supplied maxUploadFileSize, but if the server reports
                        // a small limit, relax the client-side restriction so large files
                        // (eg. 256MB) can still be selected. Server-side limits still apply.
                        const MIN_ALLOWED_BYTES = 300 * 1024 * 1024; // 300MB
                        if (defs.maxUploadFileSize && defs.maxUploadFileSize > 0) {
                            rs.maxFileSize = (defs.maxUploadFileSize < MIN_ALLOWED_BYTES) ? 1024 * 1024 * 1024 : defs.maxUploadFileSize;
                        } else {
                            rs.maxFileSize = undefined;
                        }
                        if (props.mode === FileDisplayModeEnum.Images) {
                            rs.allowedExtensions = defs.allowedImageTypes;
                        }
                        if (props.mode === FileDisplayModeEnum.Attachments) {
                            rs.allowedExtensions = defs.allowedAttachmentTypes;
                        }
                        if (props.mode === FileDisplayModeEnum.All) {
                            rs.allowedExtensions = defs.allowedAttachmentTypes.concat(defs.allowedImageTypes);
                        }

                        state.fileRestrict = rs;
                        state.defaultsLoaded = true;


                        setState({ ...state });
                        break;

                    case "Error":
                    default:
                        alert('Error loading Defaults - ' + res.callStatusMessage);
                }
            })
            .catch(err => {
                alert('Error - ' + err.toString());
            });

    }

    // HandleErrors(response: any) {
    //     if (!response.ok) {
    //         throw Error(response.statusText);
    //     }
    //     return response;
    // }

    const onAdd = (e: UploadOnAddEvent) => {
        console.log('onAdd: ', e.affectedFiles);

        // Only notify parent that an upload has started if autoUpload is enabled
        if (props.autoUpload !== false) {
            try {
                if (props.onUploadStart) props.onUploadStart();
            } catch (err: any) { }
        }

        state.files= e.newState;
        setState({ ...state });
        // If autoUpload is disabled, inform parent of the full current file selection (not just the delta)
        if (props.autoUpload === false) {
            try {
                if (props.onFilesSelected) props.onFilesSelected(e.newState.map(f => ({ uid: f.uid, name: f.name, status: f.status, progress: f.progress, raw: (f as any).getRawFile ? (f as any).getRawFile() : null } as any)));
            } catch (err: any) { }
        }
    }

    const onBeforeRemove = (e:UploadOnBeforeRemoveEvent) => {
        //Assuming only one file removed at a time
        if (e.files.length >= 1) {
            e.additionalData = {'fileId': e.files[0].uid};
        }
    }

    const onRemove = (e: UploadOnRemoveEvent) => {
        console.log('onRemove: ', e.affectedFiles);

        state.files= e.newState;
        setState({ ...state });
        if (props.autoUpload === false) {
            try {
                if (props.onFilesSelected) props.onFilesSelected(e.newState.map(f => ({ uid: f.uid, name: f.name, status: f.status, progress: f.progress, raw: (f as any).getRawFile ? (f as any).getRawFile() : null } as any)));
            } catch (err: any) { }
        }
    }

    const onProgress = (e: UploadOnProgressEvent) => {
        console.log('onProgress: ', e.affectedFiles);

        state.files= e.newState;
        setState({ ...state });
        try {
            const pf = (e.affectedFiles && e.affectedFiles.length > 0) ? e.affectedFiles[0] : null;
            const prog = pf && typeof (pf.progress) === 'number' ? pf.progress : 0;
            if (props.onUploadProgress) props.onUploadProgress(prog);
        } catch (err: any) { }
    }

    const onStatusChange = (e: UploadOnStatusChangeEvent) => {
        state.files= e.newState;
        setState({ ...state });
        // use guid returned from server to link it to TCB object
        if (e.response?.response) {
            const ufi: UploadFileInfo = {
                uid: e.response?.response,
                name: '',
                status: 4,
                progress: 100
            }
            props.onChange([ufi]);
        }
    }

    // Expose a manual upload method when consumer sets autoUpload={false}
    const startUpload = async (): Promise<UploadFileInfo[]> => {
        if (!state.files || state.files.length === 0) return [];
        try {
            if (props.onUploadStart) props.onUploadStart();

            const results: UploadFileInfo[] = [];
            for (const f of state.files) {
                // Kendo file item exposes getRawFile()
                const raw = (f as any).getRawFile ? (f as any).getRawFile() : null;
                if (!raw) continue;
                const form = new FormData();
                form.append('file', raw, f.name);

                const saveUrl = props.userInf.currProject.apiUrl + '/api/file/SaveFileForm';

                const resp = await fetch(saveUrl, { method: 'POST', body: form, headers: { 'Authorization': 'Bearer ' + props.userInf.token } });
                if (!resp.ok) throw Error(resp.statusText);
                const j = await resp.json();
                if (j && j.callStatus === 'OK' && j.result) {
                    const uid = j.result.fileId || j.response || j.result.fileUid || '';
                    const ufi: UploadFileInfo = { uid: uid, name: '', status: 4, progress: 100 };
                    // notify parent like normal upload
                    props.onChange && props.onChange([ufi]);
                    results.push(ufi);
                } else {
                    throw new Error(j.callStatusMessage || 'Upload failed');
                }
            }

            // best-effort progress hook
            if (props.onUploadProgress) props.onUploadProgress(100);
            return results;
        } catch (err: any) {
            alert('Upload error - ' + err.toString());
            return [];
        }
    }

    useImperativeHandle(ref, () => ({ startUpload }));

    // Trigger manual upload when parent increments startUploadToken
    const lastTokenRef = useRef<number | undefined>(undefined);
    useEffect(() => {
        const tok = props.startUploadToken;
        if (typeof tok === 'number' && lastTokenRef.current !== tok) {
            lastTokenRef.current = tok;
            // fire and forget; startUpload will call props.onChange when done
            startUpload().then(() => { }).catch(() => { });
        }
    }, [props.startUploadToken]);

//NOTE: Below block was changed:
//                    saveHeaders={{ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + props.userInf.token }}
// responseType="text"
    if (state.defaultsLoaded) {
        const uploadClass = props.hideButtons ? 'file-upload-hide-buttons' : '';
        return (
            <div className={uploadClass}>
            <Upload
                autoUpload={props.autoUpload !== false}
                batch={false}
                multiple={props.multiple ?? false}
                files={state.files}
                restrictions={state.fileRestrict}
                onAdd={onAdd}
                onProgress={onProgress}
                onBeforeRemove={onBeforeRemove}
                onRemove={onRemove}
                onStatusChange={onStatusChange}
                withCredentials={false}
                saveHeaders={{ 'Authorization': 'Bearer ' + props.userInf.token }}
                responseType="json"
                saveUrl={props.userInf.currProject.apiUrl + '/api/file/SaveFileForm'}
                removeMethod='POST'
                removeHeaders={{ 'Authorization': 'Bearer ' + props.userInf.token }}
                removeUrl={props.userInf.currProject.apiUrl + '/api/file/RemoveFile'}
            />
            </div>
        );
    } else {
        return (<span className="fileUploadDefLoading k-icon k-font-icon k-i-loading" />);
    }
});

export default connector(FileUploadCtl);
